import XLSX from 'xlsx';

const moment = require('moment');

const headers = [
  'patent_product_id',
  'patent_name',
  'patent_number',
  'patent_ingredients',
  'patent_roles',
  'patent_related_incis',
];
const cols = [
  { width: 25 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
];

export default {
  methods: {
    async export(items) {
      // /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(
        await this.createXLSData(items),
      );

      /* Set worksheet sheet to "wide" */
      ws['!margins'] = {
        left: 1.0,
        right: 1.0,
        top: 1.0,
        bottom: 1.0,
        header: 0.5,
        footer: 0.5,
      };
      ws['!cols'] = cols;

      let i;
      for (i in ws) {
        /* all keys that do not begin with "!" correspond to cell addresses */
        if (i.indexOf('!') === -1) {
          ws[i].s = {
            alignment: {
              wrapText: 1, // any truthy value here
            },
          };
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
      const fileName = `Export_${moment().format('DD/MM/YYYY')}.xlsx`;
      /* generate file and send to client */
      XLSX.writeFile(wb, fileName);
    },
    async createXLSData(items) {
      try {
        const data = [this.excelHeaders()];

        items.forEach((item) => {
          data.push([
            item.productId,
            item.name,
            item.number,
            item.ingredients.join('; '),
            item.roles.join('; '),
            item.relatedIncis.join('; '),
          ]);
        });
        return data;
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    excelHeaders() {
      const headerLabels = [];

      headers.forEach((header) => {
        headerLabels.push(
          this.labels.exportsHeader[header],
        );
      });
      return headerLabels;
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/exportPatent.js